import { ContractorDocumentType } from './contractor-document.enum';

export interface ContractorDocument {
  id: string;
  documentType: ContractorDocumentType;
  documentTypeDisplay: string;
  fileName: string;
  isVerified: boolean;
  expirationDate: string;
  uploadedAt: string;
  isExpired: boolean;
  isExpiringSoon: boolean;
  previewUrl: string;
  /**
   * Pre-signed URL to a small JPEG thumbnail (page-1 for PDFs, resized for
   * images) suitable for an `<img>` src. Null/absent when the thumbnail has not
   * been generated yet (async), generation failed, or storage is local — in
   * which case the UI falls back to a generic file-type icon.
   */
  thumbnailUrl?: string | null;
}

export interface ContractorDocumentPayload {
  documentType: ContractorDocumentType;
  fileName: string;
  fileContent: string;
  mimeType?: string;
  expirationDate?: string;
}

/**
 * Query parameters for document listing endpoints.
 * All parameters are optional and combine with AND logic.
 * Preserves newest-first (UploadedAt) sort.
 */
export interface DocumentListQueryParams {
  /**
   * Filter by multiple document types (supports repeatable query param).
   * Examples:
   * - ?documentTypes=Resume
   * - ?documentTypes=Resume&documentTypes=W9Form
   * When not specified, all types are included (no type filter applied).
   * Uses SQL IN logic when multiple types are provided.
   */
  documentTypes?: ContractorDocumentType[];

  /**
   * Filter by verification status.
   * When not specified, all verification statuses are included.
   */
  isVerified?: boolean;

  /**
   * Include expired documents.
   * Default: true (include all documents)
   * When false, excludes documents where ExpirationDate is in the past.
   * Documents with no expiration date are always included.
   */
  includeExpired?: boolean;
}
